export default __webpack_public_path__ + "static/media/messenger.2a98e91c.svg";